<nz-spin [nzSpinning]="loading">
    <nz-form-item>
        <nz-form-control>
            <nz-form-item>
                <nz-flex nzGap="small" class="w-100">
                    <nz-select
                        nzShowSearch
                        nzPlaceHolder="Lietotājs"
                        [(ngModel)]="selectedUserId"
                        [ngModelOptions]="{ standalone: true }"
                        nzAllowClear
                    >
                        @for (user of users; track user.id) {
                            <nz-option [nzLabel]="userToString(user)" [nzValue]="user.id"></nz-option>
                        }
                    </nz-select>
                    <button nz-button class="btn-success" (click)="addDocumentFileSigner()">Pievienot parakstītāju</button>
                </nz-flex>
            </nz-form-item>
        </nz-form-control>
    </nz-form-item>
    @if (documentFileSigners) {
        <nz-table #documentFileSignersTable [nzData]="documentFileSigners" nzSize="small" [nzFrontPagination]="false">
            <thead>
                <tr>
                    <th [nzSortFn]="sortByDocumentFileSignerUser">Parakstītājs</th>
                    <th [nzSortFn]="sortByDocumentFileSignerLastNotificationTimestamp">Pēdējais paziņojums nosūtīts</th>
                    @if (!multiDocumentFileMode) {
                        <th [nzSortFn]="sortByDocumentFileSignerSignedTimestamp">Parakstīšanas datums</th>
                    }
                    <th></th>
                </tr>
            </thead>
            <tbody>
                @for (documentFileSigner of documentFileSignersTable.data; track documentFileSigner.id; let i = $index) {
                    <tr>
                        <td>{{ userToString(documentFileSigner.signerUser) }}</td>
                        <td>
                            {{
                                documentFileSigner.lastNotificationTimestamp
                                    ? (documentFileSigner.lastNotificationTimestamp | date: DATE_TIME_FORMAT)
                                    : '-'
                            }}
                        </td>
                        @if (!multiDocumentFileMode) {
                            <td>
                                {{ documentFileSigner.signedTimestamp ? (documentFileSigner.signedTimestamp | date: DATE_TIME_FORMAT) : '-' }}
                            </td>
                        }
                        <td>
                            <nz-flex nzGap="small">
                                @if (!documentFileSigner.signedTimestamp) {
                                    <button
                                        *hasPermission="[GroupPermissions.DOCUMENT_EDIT]"
                                        nz-button
                                        nzType="info"
                                        (click)="sendDocumentSigningNotification(documentFileSigner)"
                                    >
                                        <span nz-icon nzType="mail" nzTheme="outline"></span>
                                    </button>
                                    <button
                                        *hasPermission="[GroupPermissions.DOCUMENT_EDIT]"
                                        nz-button
                                        nzDanger
                                        (click)="deleteDocumentFileSigner(i)"
                                    >
                                        <i nz-icon nzType="delete"></i>
                                    </button>
                                }
                            </nz-flex>
                        </td>
                    </tr>
                }
            </tbody>
        </nz-table>
    }
    <div *nzModalFooter>
        <button nz-button nzType="default" [disabled]="loading" (click)="close()">Aizvērt</button>
    </div>
</nz-spin>
